
import Vue from 'vue';
import { autoComplete, extractErrorMessage } from '@/utils/Util';
import EntityMetaDialog from '@/components/misc/EntityMetaDialog.vue';
import IoTDeviceService from '@/services/IoTDeviceService';
import DeviceService from '@/services/DeviceService';
import IotDeviceDisableDialog from './IotDeviceDisableDialog.vue';
import TenantInfoDialog from '../tenant/TenantInfoDialog.vue';
import PropertyInfoDialog from '../property/PropertyInfoDialog.vue';
import ConnectorInfoDialog from '../connector/ConnectorInfoDialog.vue';
import DeviceInfoDialog from '../device/DeviceInfoDialog.vue';
import IotDevicePortConfigDialog from './IotDevicePortConfigDialog.vue';
import IotDeviceReplacementDialog from './IotDeviceReplacementDialog.vue';
import PropertyService from '@/services/PropertyService';
import ConnectorService from '@/services/ConnectorService';
import AlertsListDialog from '../alert/AlertsListDialog.vue';
import NotesListDialog from '../note/NotesListDialog.vue';

export default Vue.extend({
  name: 'IotDeviceEditDialog',

  props: ['iotdevice'],
  components: {
    EntityMetaDialog,
    IotDeviceDisableDialog,
    DeviceInfoDialog,
    IotDevicePortConfigDialog,
    IotDeviceReplacementDialog,
    AlertsListDialog,
    NotesListDialog,
  },
  data: (vm: any): any => ({
    localdialog: false,
    localIotdevice: {} as any,
    valid: true,
    passwordToggle: false,
    alertText: '',
    alertVisible: false,
    alertType: 'error',
    loading: false,
    loadingTenant: false,
    requiredRule: [(v: string) => !!v || vm.requiredError],
    requiredSelect: [
      (v: any) => (!!v && Object.keys(v).length > 0) || vm.requiredError,
    ],
    vpnOptions: ['on', 'off'],
    hardwareComponents: ['base', 'display', 'mbus', 'gsm', 'ir-multiplexer'],
    connectivityMethods: ['ETH', 'WIFI', 'GSM'],
    iotDeviceTypes: ['E32', 'P42', 'OTHER'],
    loadingProperties: false,
    loadingConnectors: false,
    connectors: [],
    properties: [],
    associatedTenant: null as any,
    associatedProperty: null as any,
    associatedConnector: null as any,
    associatedMonitoringDevice: {} as any,
    associatedAlerts: [],
    associatedNotes: [] as any[],
    updatedAssociatedTenant: null as any,
    updatedAssociatedProperty: null as any,
    updatedAssociatedConnector: null as any,
    initializing: false, // loading initial data
    associationsLoaded: false, // all initial associations loaded
  }),
  async created() {
    this.localIotdevice = JSON.parse(JSON.stringify(this.iotdevice));
  },
  methods: {
    close() {
      this.localdialog = false;
    },
    clear() {
      this.associatedTenant = null;
      this.associatedProperty = null;
      this.associatedConnector = null;
      this.updatedAssociatedTenant = null;
      this.updatedAssociatedProperty = null;
      this.updatedAssociatedConnector = null;
      this.associatedAlerts = [];
      this.associatedNotes = [];
      this.alertVisible = false;
      this.loading = false;
    },
    dismiss() {
      this.clear();
      this.close();
    },
    validate() {
      if (this.editForm.validate()) {
        this.save();
      }
    },
    onItemReplacement(iotdevice: any) {
      this.$emit('update', iotdevice);
      this.dismiss();
    },
    onItemDisable() {
      this.iotdevice.enabled = false;
      this.$emit('update', this.iotdevice);
      this.localIotdevice.enabled = false;
    },
    async onItemEnable() {
      await IoTDeviceService.activateIoTDevice(this.iotdevice.uuid);
      this.iotdevice.enabled = true;
      this.$emit('update', this.iotdevice);
      this.localIotdevice.enabled = true;
    },
    save() {
      this.alertVisible = false;
      this.loading = true;

      let type;
      let description;
      let state;
      let connectivity;
      let mqttPassword;
      let config;
      let hardware;
      let associatedTenantUUID;
      let associatedPropertyUUID;
      let associatedConnectorUUID;

      if (this.localIotdevice.type !== this.iotdevice.type) {
        type = this.localIotdevice.type;
      }
      if (this.localIotdevice.description !== this.iotdevice.description) {
        description = this.localIotdevice.description;
      }
      if (this.localIotdevice.connectivity !== this.iotdevice.connectivity) {
        connectivity = this.localIotdevice.connectivity;
      }
      if (this.localIotdevice.state !== this.iotdevice.state) {
        state = this.localIotdevice.state;
      }
      if (this.localIotdevice.mqttPassword !== this.iotdevice.mqttPassword) {
        mqttPassword = this.localIotdevice.mqttPassword;
      }
      if (
        JSON.stringify(this.localIotdevice.config) !=
        JSON.stringify(this.iotdevice.config)
      ) {
        config = this.localIotdevice.config;
      }
      if (
        JSON.stringify(this.localIotdevice.hardware) !=
        JSON.stringify(this.iotdevice.hardware)
      ) {
        hardware = this.localIotdevice.hardware;
      }
      // console.log(this.updatedAssociatedTenant, this.associatedTenant)
      if (
        this.updatedAssociatedTenant == null &&
        this.associatedTenant != null
      ) {
        associatedTenantUUID = '';
      } else if (
        this.updatedAssociatedTenant?.uuid !== this.associatedTenant?.uuid
      ) {
        associatedTenantUUID = this.updatedAssociatedTenant?.uuid;
      }

      // console.log(this.updatedAssociatedProperty, this.associatedProperty)
      if (
        this.associationsLoaded &&
        this.updatedAssociatedProperty === null &&
        this.associatedProperty !== null
      ) {
        associatedPropertyUUID = '';
      } else if (
        this.updatedAssociatedProperty?.uuid !== this.associatedProperty?.uuid
      ) {
        associatedPropertyUUID = this.updatedAssociatedProperty?.uuid;
      }
      // console.log(this.updatedAssociatedConnector, this.associatedConnector)
      if (
        this.associationsLoaded &&
        this.updatedAssociatedConnector === null &&
        this.associatedConnector !== null
      ) {
        associatedConnectorUUID = '';
      } else if (
        this.updatedAssociatedConnector?.uuid !== this.associatedConnector?.uuid
      ) {
        associatedConnectorUUID = this.updatedAssociatedConnector?.uuid;
      }

      IoTDeviceService.updateIoTDevice(
        this.iotdevice.uuid,
        type,
        description,
        connectivity,
        state,
        mqttPassword,
        config,
        hardware,
        associatedTenantUUID,
        associatedPropertyUUID,
        associatedConnectorUUID
      )
        .then((iotdevice: any) => {
          this.alertType = 'success';
          this.alertText = this.$t('iotdevice.successUpdate') as string;
          this.alertVisible = true;

          this.localIotdevice = iotdevice;

          this.$emit('update', iotdevice);
          setTimeout(() => {
            this.dismiss();
          }, 1500);
        })
        .catch((err) => {
          console.log(err);
          console.log(err.response);
          this.alertType = 'error';
          this.alertText =
            this.$t('iotdevice.errorUpdate') + ' ' + extractErrorMessage(err);
          this.alertVisible = true;
          this.loading = false;
        });
    },
    getProperties() {
      if (!this.updatedAssociatedTenant) return;

      this.properties = [];
      this.loadingProperties = true;

      PropertyService.getAllCollectionPages(this.updatedAssociatedTenant.uuid)
        .then((properties: any[]) => {
          this.loadingProperties = false;

          this.properties = properties;
        })
        .catch((err: any) => {
          console.log(err, err.response);
          this.alertType = 'error';
          this.alertText =
            this.$t('property.loadingError') + ' ' + extractErrorMessage(err);
          this.alertVisible = true;
          this.loadingProperties = false;
        });
    },
    getConnectors() {
      if (!this.updatedAssociatedTenant) return;

      this.connectors = [];
      this.loadingConnectors = true;

      ConnectorService.getAllCollectionPages(this.updatedAssociatedTenant.uuid)
        .then((connectors: any[]) => {
          this.loadingConnectors = false;

          this.connectors = connectors;
        })
        .catch((err: any) => {
          console.log(err, err.response);
          this.alertType = 'error';
          this.alertText =
            this.$t('connector.loadingError') + ' ' + extractErrorMessage(err);
          this.alertVisible = true;
          this.loadingConnectors = false;
        });
    },
    async getAssociatedTenant() {
      try {
        this.associatedTenant = await IoTDeviceService.getAssociatedTenant(
          this.iotdevice.uuid
        );
        this.updatedAssociatedTenant = this.associatedTenant;
      } catch (err: any) {
        console.log(err);
        console.log(err.response);
      }
    },
    async getAssociatedProperty() {
      try {
        this.associatedProperty = await IoTDeviceService.getAssociatedProperty(
          this.iotdevice.uuid
        );
        this.updatedAssociatedProperty = this.associatedProperty;
      } catch (err: any) {
        console.log(err);
        console.log(err.response);
      }
    },

    async getAssociatedConnector() {
      try {
        this.associatedConnector =
          await IoTDeviceService.getAssociatedConnector(this.iotdevice.uuid);
        this.updatedAssociatedConnector = this.associatedConnector;
      } catch (err: any) {
        console.log(err);
        console.log(err.response);
      }
    },

    async getAssociatedMonitoringDevice() {
      try {
        this.associatedMonitoringDevice =
          await IoTDeviceService.getAssociatedMonitoringDevice(
            this.iotdevice.uuid
          );
      } catch (err: any) {
        console.log(err);
        console.log(err.response);
      }
    },
    async getAssociatedAlerts() {
      try {
        this.associatedAlerts = await IoTDeviceService.getAssociatedAlerts(
          this.iotdevice.uuid
        );
      } catch (err: any) {
        console.log(err);
        console.log(err.response);
      }
    },
    async onAlertDelete(item: any) {
      this.associatedAlerts.splice(
        this.associatedAlerts.findIndex(
          (value: any) => value.uuid === item.uuid
        ),
        1
      );
    },
    async onAlertCreate(item: any) {
      this.associatedAlerts.push(item);
    },
    async onAlertUpdate(item: any) {
      this.associatedAlerts.splice(
        this.associatedAlerts.findIndex(
          (value: any) => value.uuid === item.uuid
        ),
        1
      );
      this.associatedAlerts.push(item);
    },
    async getAssociatedNotes() {
      try {
        this.associatedNotes = await IoTDeviceService.getNotes(this.iotdevice.uuid);
      } catch(err: any) { console.log(err, err.response); }
    },
    async onNoteCreate(item: any) {
      try {
        const note = await IoTDeviceService.createNote(this.iotdevice.uuid, item.body, item.visibility);
        this.associatedNotes.push(note);
      } catch(err: any) { console.log(err, err.response); }
    },
    async onNoteUpdate(item: any) {
      try {
        const note = await IoTDeviceService.updateNote(this.iotdevice.uuid, item.uuid, item.body);
        const idx = this.associatedNotes.findIndex((n: any) => n.uuid === item.uuid);
        if(idx >= 0) this.associatedNotes.splice(idx, 1, note);
      } catch(err: any) { console.log(err, err.response); }
    },
    async onNoteDelete(item: any) {
      try {
        await IoTDeviceService.deleteNote(this.iotdevice.uuid, item.uuid);
        this.associatedNotes.splice(this.associatedNotes.findIndex((n: any) => n.uuid === item.uuid), 1);
      } catch(err: any) { console.log(err, err.response); }
    },
    autoComplete,
  },
  watch: {
    updatedAssociatedTenant() {
      // not clearing while initializing
      if (this.initializing) return;

      this.updatedAssociatedConnector = null;
      this.updatedAssociatedProperty = null;
      this.getProperties();
      this.getConnectors();
    },
    iotdevice() {
      this.localIotdevice = JSON.parse(JSON.stringify(this.iotdevice));

      if (
        this.localIotdevice.type === 'E32' &&
        !('mbus' in this.localIotdevice.config)
      ) {
        this.localIotdevice.config.mbus = {};
      }
    },
    async localdialog(value: boolean) {
      if (!value) {
        return this.clear();
      }
      this.initializing = true;
      this.associationsLoaded = false;

      try {
        //  first tenant
        await this.getAssociatedTenant();
        // then tenant dependant entities
        await this.getProperties();
        await this.getConnectors();

        await this.getAssociatedProperty();
        await this.getAssociatedConnector();
        await this.getAssociatedAlerts();
        await this.getAssociatedNotes();

        this.associationsLoaded = true;
      } finally {
        this.initializing = false;
      }
    },
  },

  computed: {
    editForm(): any {
      return this.$refs.editForm;
    },
    requiredError(): any {
      return this.$t('required');
    },
    currentTenant(): any {
      return this.$root.$store.state.session.selectedTenant.uuid;
    },
    activeLabel() {
      if (this.iotdevice.enabled) return this.$t('enabled');
      return this.$t('disabled');
    },
    monitoringLabel() {
      if (this.associatedAlerts.length > 0) return this.$t('on');
      return this.$t('off');
    },
  },
});
